import Layout from '../../UI/Layout/Layout'
import Hero from './Hero/Hero'
import Split from './Split/Split'
import Contact from './Contact/Contact'
import Separator from './Separator/Separator'

import imageIntro from '../../../assets/image/home/intro/image.png'
import imageWho from '../../../assets/image/home/who/image.png'
import imageJournalismus from '../../../assets/image/home/journalismus/image.png'

const Home = () => {
  return (
    <Layout authLevelRequired={false} hideNavigation>
      <Hero />
      <Separator />
      <Split textKey="home.intro" image={imageIntro} />
      <Split textKey="home.who" reverse image={imageWho} />
      <Split textKey="home.journalismus" image={imageJournalismus} />
      <Contact />
    </Layout>
  )
}

export default Home
